import { FC } from 'react';
import { cn } from '../../utils/cn';

interface LegendItemProps {
  color: string;
  label: string;
}

const LegendItem: FC<LegendItemProps> = ({ color, label }) => (
  <div className="flex items-center gap-2">
    <span className={cn('h-3 w-3 rounded-sm border', color)} aria-hidden="true" />
    <span className="text-xs text-gray-600 dark:text-slate-400">{label}</span>
  </div>
);

export const AvailabilityLegend: FC = () => {
  return (
    <div
      className="mt-4 flex flex-wrap items-center justify-center gap-4 pt-4 border-t border-gray-100 dark:border-slate-700"
      role="legend"
      aria-label="Calendar availability legend"
    >
      <LegendItem color="bg-green-50 dark:bg-green-900/30 border-green-200 dark:border-green-800" label="Available" />
      <LegendItem color="bg-yellow-50 dark:bg-yellow-900/30 border-yellow-200 dark:border-yellow-800" label="Limited" />
      <LegendItem color="bg-gray-100 dark:bg-slate-800 border-gray-200 dark:border-slate-700" label="Unavailable" />
      <LegendItem color="bg-primary-600 border-primary-600" label="Selected" />
    </div>
  );
};

AvailabilityLegend.displayName = 'AvailabilityLegend';
